import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  TeamOutlined,
} from '@ant-design/icons'
import { Card, Spin } from '@surecompanies/core_components'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import Page from 'layouts/Page'
import React from 'react'
import AllCustomersTable from './components/AllCustomersTable'
import styles from './CustomerOnboarding.module.scss'
import useOnboardingStats, {
  OnboardingCounts,
} from './hooks/useOnboardingStats'

interface StatItem {
  title: string
  key: keyof OnboardingCounts
  icon: React.ReactNode
}

const statConfig: StatItem[] = [
  {
    title: 'Total Customers',
    key: 'totalCustomers',
    icon: <TeamOutlined style={{ fontSize: 18, color: '#4a5568' }} />,
  },
  {
    title: 'Complete',
    key: 'completeOnboarding',
    icon: <CheckCircleOutlined style={{ fontSize: 18, color: '#38a169' }} />,
  },
  {
    title: 'Onboarding',
    key: 'onboarding',
    icon: <ClockCircleOutlined style={{ fontSize: 18, color: '#3182ce' }} />,
  },
]

export default function CustomerOnboarding() {
  const { counts, isLoading } = useOnboardingStats()

  return (
    <Page
      title="Census Onboarding"
      breadcrumb={
        <BreadcrumbNav
          items={[{ title: 'Home', path: '/' }, { title: 'Census Onboarding' }]}
        />
      }
    >
      <p className={styles.subtitle}>
        Manage Census Onboarding and configuration
      </p>
      <Spin spinning={isLoading}>
        <div className={styles.cardsGrid}>
          {statConfig.map((stat) => (
            <div className={styles.statCard} key={stat.key}>
              <Card>
                <div className={styles.cardHeader}>
                  <span className={styles.cardTitle}>{stat.title}</span>
                  {stat.icon}
                </div>
                <div className={styles.cardValue}>{counts[stat.key]}</div>
              </Card>
            </div>
          ))}
        </div>
      </Spin>
      <AllCustomersTable />
    </Page>
  )
}
